import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch } from "react-redux";
import { firestoreActions } from "store/firestore";

export default function QueryLoader({ name, q }) {

  const dispatch = useDispatch();
  const [snapshot, loading, error] = useCollection(q);

  useEffect(() => {
    dispatch(
      firestoreActions.setQueryState({
        name,
        docs: snapshotToArray(snapshot),
        loading,
        error,
      })
    );
  }, [snapshot, loading, error, name, q, dispatch]);

  return null;
}
